/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Product_Out_Of_Stock_Note1Inputs */

const vi_sitesettings_product_out_of_stock_note1 = /** @type {(inputs: Sitesettings_Product_Out_Of_Stock_Note1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi chú khi hết hàng`)
};

/**

* @param {Sitesettings_Product_Out_Of_Stock_Note1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_product_out_of_stock_note1 = /** @type {((inputs?: Sitesettings_Product_Out_Of_Stock_Note1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Product_Out_Of_Stock_Note1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_product_out_of_stock_note1(inputs)
});
export { sitesettings_product_out_of_stock_note1 as "siteSettings_product_out_of_stock_note" }